import React from 'react';
import { motion } from 'framer-motion';
import Pricing from '../sections/Pricing.js';
import { pageWrapperStyle } from '../../styles/pageStyles.js';

const PricingPage = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      style={pageWrapperStyle}
    >
      <Pricing />
    </motion.div>
  );
};

export default PricingPage;
